import type { FaireProductEntity } from "../../entity_types/product";

export const p_fwvp4fna9f: FaireProductEntity = {
  token: "p_fwvp4fna9f",
  type: "product",
  name: "Warhol Banana Stress Reliever",
  brandToken: "b_xhktv33sen",
  brandName: "Chronicle Books",
  imageUrl:
    "https://cdn.faire.com/fastly/a5747f16d30576b31cd0daf8d157be4512ec5ab6738132688a5a4dfa8b381d27.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a0a9e86267a499b07005c615ff6d740bdc4420a11f490ffa678deafb0c8f3ca9.jpeg",
  ],
  priceDollars: 4.67,
  description:
    'The Andy Warhol Banana Stress Reliever is great for reducing physical discomfort and relieving mental tension in your body. Squeezing will improve focus, increase strength, and soothe your mind.\n\n• Slow-rising polyurethane\n• Box size: 2.75 x 3.5 x 2.35", 70 x 89 x 60 mm\n• Die-cut window on two sides of the box\n• Squeezable soup can: 2.25 x 3.5", 57 x 89 mm\n• Giftable, fun version of the traditional stress ball',
  tags: [],
  msrpDollars: 8.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:58:37.490Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
